import { render, staticRenderFns } from "./StyleGuide.vue?vue&type=template&id=6af1b65a&scoped=true&"
import script from "./StyleGuide.vue?vue&type=script&lang=js&"
export * from "./StyleGuide.vue?vue&type=script&lang=js&"
import style0 from "./StyleGuide.vue?vue&type=style&index=0&id=6af1b65a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af1b65a",
  null
  
)

component.options.__file = "StyleGuide.vue"
export default component.exports